export default class ModifierFunctions {
    static getModifierWeight(modifierChoice) {
        if(!modifierChoice || modifierChoice.quantity < 1) {
            return 0;
        }

        const portionWeight = modifierChoice.portion === 'first-half' || modifierChoice.portion === 'second-half' ? 0.5 : 1;
        const sizeWeight = modifierChoice.size === 'extra' ? 2 : 1;

        return modifierChoice.quantity * portionWeight * sizeWeight;
    }

    static maxQuantityHasNotBeenExceeded(modifierKey, itemComponent) {
        //First short-circuit this check if the key is in a radio group, in case they add max toppings then try to select
        let isRadio = false;
        itemComponent.state.styles.forEach( (val, ind, arr) => {
            let modifiersForStyleGroup = val.modifiers;
            modifiersForStyleGroup.forEach( (modVal, modInd, modArr) => {
                if(modVal === modifierKey) {
                    //This is part of a radio group
                    isRadio = true;
                }
            })
        });
        if(isRadio) {
            return true;
        }
        const maxQuantity = itemComponent.state?.modifiers?.[modifierKey]?.maxQuantity;
        const max = maxQuantity === -1 ? 99 : (maxQuantity ?? 99);
        const itemMax = itemComponent.state.maxToppings === -1 ? 99: itemComponent.state.maxToppings; // default to max 9
        let chosenModifers = itemComponent.state.choices.modifiers;
        let chosenForItem = 0;
        //We also need to exclude all of our 'styles'
        let allStyleMods = {};
        itemComponent.state.styles.forEach( (val, ind, arr) => {
            let styleMods = val.modifiers;
            styleMods.forEach( (sVal, sInd, sArr) => {
                allStyleMods[sVal] = true;
            });
        });
        for (const modID in chosenModifers) {
            if (chosenModifers.hasOwnProperty(modID)) {
                let isStyleMod = allStyleMods[modID];
                if(!isStyleMod && modID !== '0') {
                    //Only proceed to count the mod if it isn't a style mod
                    const modifier = chosenModifers[modID];
                    chosenForItem = chosenForItem + ModifierFunctions.getModifierWeight(modifier);
                }
            }
        }

        //Finally the considerations for when there is a maximum for a single toppingGroup
        let isInvalidAtGroupLevel = false;
        itemComponent.state.options.forEach( (val, ind, arr) => {
            let hasMaxToppings = val.maxAllowed !== 0; //If 0, ignore
            if(hasMaxToppings) {
                let numToppingsInGroup = 0;
                let currentModifierIsInGroup = false; //Check to make sure the group we're checking is relevant
                val.modifiers.forEach( (modVal, modInd, modArr) => {
                    if(modVal === modifierKey) {
                        currentModifierIsInGroup = true;
                    }
                    let choiceForMod = itemComponent.state.choices.modifiers[modVal];
                    numToppingsInGroup = numToppingsInGroup + ModifierFunctions.getModifierWeight(choiceForMod);
                });
                if(numToppingsInGroup >= val.maxAllowed && currentModifierIsInGroup) {
                    isInvalidAtGroupLevel = true;
                }
            }
        });
        if(isInvalidAtGroupLevel) return false;
        if(itemComponent.state.choices.modifiers[modifierKey].quantity >= max) {
            window.alert(`Max Quantity of ${this.state.modifiers[modifier].name} exceeded`);
            return false;
        }
        if(chosenForItem >= itemMax) return false;

        return true;
    }

    /**
     * 
     * @param {Event} changeEvent Event triggered by changing the quantity of the total Modifier
     * Responds to direct user input through typing
     */
    static handleModifierQuantityChange(changeEvent, modifier) {
        const newVal = changeEvent.target.value;
        const old = this.state;
        old.choices.modifiers[modifier].quantity = newVal;
        this.setState(old);
    }

    /**
     * Increases quantity by 1 to a maximum of 99
     */
    static increaseModifierQuantity(modifier) {
        if(ModifierFunctions.maxQuantityHasNotBeenExceeded(modifier, this)) {
            const newQuantity = this.state.choices.modifiers[modifier].quantity + 1;
            if(newQuantity < 99) {
                const old = this.state;
                old.choices.modifiers[modifier].quantity = newQuantity;
                this.setState(old);
            }
        }
    }

    /**
     * Decreases quantity by 1 to a minimum of 0
     */
    static decreaseModifierQuantity(modifier) {
        const newQuantity = this.state.choices.modifiers[modifier].quantity - 1;
        if(newQuantity > 0) {  
            const old = this.state;
            old.choices.modifiers[modifier].quantity = newQuantity;
            this.setState(old);
        }
    }
    

    /**
     * 
     * @param {number} key Key of modifier to update to 'Extra'
     * @param {Boolean} includedModifier Whether or not this modifier was included
     */
    static setExtra(key, includedModifier) {
        if(this.state.modifiers[key].showDouble && ModifierFunctions.maxQuantityHasNotBeenExceeded(key, this)) { 
            const old = this.state;
            if(includedModifier) {
                old.choices.includedModifiers[key].size = 'extra';
            }else {
                old.choices.modifiers[key].size = 'extra';
            }
            this.setState(old);
        }
    }

    /**
     * 
     * @param {number} key Key of modifier to update to 'Normal'
     * @param {Boolean} includedModifier Whether or not this modifier was included
     */
    static setNormalSize(key, includedModifier) {
        const old = this.state;
        if(includedModifier) {
            old.choices.includedModifiers[key].size = 'normal';
        }else {
            old.choices.modifiers[key].size = 'normal';
        }
        this.setState(old);
    }
    /**
     * 
     * @param {number} key Key of modifier to update to 'Light'
     * @param {Boolean} includedModifier Whether or not this modifier was included
     */
    static setLight(key, includedModifier) {
        const old = this.state;
        if(includedModifier) {
            old.choices.includedModifiers[key].size = 'light';
        }else {
            old.choices.modifiers[key].size = 'light';
        }
        this.setState(old);
    }

    /**
     * 
     * @param {number} key Key of modifier to update to 'First-Half'
     * @param {Boolean} includedModifier Whether or not this modifier was included
     */
    static setFirstHalfOnly(key, includedModifier) {
        const old = this.state;
        if(this.state.modifiers[key].showHalf && ModifierFunctions.maxQuantityHasNotBeenExceeded(key, this)) {
            if(includedModifier) {
            old.choices.includedModifiers[key].portion = 'first-half';
            }else {
                old.choices.modifiers[key].portion = 'first-half';
                old.choices.modifiers[key].quantity = 1;
            }
            this.setState(old);
        }else if(old.choices.modifiers[key].portion === 'second-half' || old.choices.modifiers[key].portion === 'whole') {
            if(includedModifier) {
            old.choices.includedModifiers[key].portion = 'first-half';
            }else {
                old.choices.modifiers[key].portion = 'first-half';
            }
            this.setState(old);
        }
    }

    /**
     * 
     * @param {number} key Key of modifier to update to 'Second-Half'
     * @param {Boolean} includedModifier Whether or not this modifier was included
     */
    static setSecondHalfOnly(key, includedModifier) {
        const old = this.state;
        if(this.state.modifiers[key].showHalf && ModifierFunctions.maxQuantityHasNotBeenExceeded(key, this)) {
            if(includedModifier) {
            old.choices.includedModifiers[key].portion = 'second-half';
            }else {
                old.choices.modifiers[key].portion = 'second-half';
                old.choices.modifiers[key].quantity = 1;
            }
            this.setState(old);
        }else if(old.choices.modifiers[key].portion === 'first-half' || old.choices.modifiers[key].portion === 'whole') {
            //Do the same if we're converting from a different portion
            if(includedModifier) {
            old.choices.includedModifiers[key].portion = 'second-half';
            }else {
                old.choices.modifiers[key].portion = 'second-half';
            }
            this.setState(old);
        }
    }

    /**
     * 
     * @param {number} key Key of modifier to update to 'Whole'
     * @param {Boolean} includedModifier Whether or not this modifier was included
     */
    static setWholePortion(key, includedModifier) {
        const old = this.state;
        if(includedModifier) {
        old.choices.includedModifiers[key].portion = 'whole';
        }else {
            if(ModifierFunctions.maxQuantityHasNotBeenExceeded(key, this)) {
                old.choices.modifiers[key].portion = 'whole';
                old.choices.modifiers[key].quantity = 1;
            }else if(old.choices.modifiers[key].portion === 'first-half' || old.choices.modifiers[key].portion === 'second-half') {
                //Double check we haven't already set this to half, allow setting to whole
                old.choices.modifiers[key].portion = 'whole';
            }
        }
        this.setState(old);
    }

    static removeOptionalModifier(key) {
        const old = this.state;
        old.choices.modifiers[key].portion = 'whole';
        old.choices.modifiers[key].size = 'normal';
        old.choices.modifiers[key].quantity = 0;
        this.setState(old);
    }

    /**
     * 
     * @param {number} key Key of included Modifier to re-add to tray
     */
    static reAddIncludedItem(key) {
        const old = this.state;
        old.choices.includedModifiers[key].quantity = 1;
        this.setState(old);
    }
    /**
     * 
     * @param {number} key Key of included Modifier to remove from tray
     */
    static excludeIncludedItem(key) {
        const old = this.state;
        old.choices.includedModifiers[key].quantity = 0;
        this.setState(old);
    }

    static determineExcludedModifiers() {
        //null safeguards.
        if (
            !this.state.includedModifiers ||
            !this.state.choices ||
            !this.state.choices.includedModifiers
        ) {
            return [];
        }
        const included = this.state.includedModifiers;
        const choices = this.state.choices.includedModifiers;
        var result = [];
        /**
         * TODO translate this to the current state structure
         */
        for (var key in included) {
            if (included.hasOwnProperty(key)) {
                // Cycle through all included toppings
                // Check to see if it is still chosen
                if(choices[key]) {
                    if(included[key].quantity === choices[key].quantity) {
                        //quantities match
                    } else {
                        result.push(key);
                    }
                }else {
                    result.push(key);
                }
            }
        }
        return result;
    }

    static determineIncludedModifiers() {
        //null safeguards.
        if (
            !this.state.includedModifiers ||
            !this.state.choices ||
            !this.state.choices.includedModifiers
        ) {
            return [];
        }
        const included = this.state.includedModifiers;
        const choices = this.state.choices.includedModifiers;
        var result = [];
        /**
         * TODO translate this to the current state structure
         */
        for (var key in included) {
            if (included.hasOwnProperty(key)) {
                // Cycle through all included toppings
                // Check to see if it is still chosen
                if(choices[key]) {
                    if(included[key].quantity === choices[key].quantity) {
                        //quantities match
                            result.push(key);
                    }
                }
            }
        }
        return result;
    }
}
